import { render, staticRenderFns } from "./C.vue?vue&type=template&id=15e5b2d6&"
import script from "./C.vue?vue&type=script&lang=js&"
export * from "./C.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports